import { render } from "./SpkSubconPrintPreview.vue?vue&type=template&id=010f1f98&scoped=true"
import script from "./SpkSubconPrintPreview.vue?vue&type=script&lang=js"
export * from "./SpkSubconPrintPreview.vue?vue&type=script&lang=js"

import "./SpkSubconPrintPreview.vue?vue&type=style&index=0&id=010f1f98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010f1f98"]])

export default __exports__